import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import contactInfo from "../data/contact";
import ContactForm from "../components/ContactForm";
import "../styles/pages/contact.css";

export default function Home() {
  return (
    <>
      <Navbar />
      <div className="contact">
        <div className="contact__container">
          <div className="contact__hero">
            <h1>get in touch </h1>
            <p>Feel free to reach out for work or collaboration.</p>
          </div>
          <div className="contact__body">
            <div className="contact__body-columns">
              {contactInfo.map((cont) => {
                return (
                  <div className="contact__item" key={cont.id}>
                    {cont.icon}
                    <div className="contact__item-info">
                      <h2>{cont.title}</h2>
                      <a href={`${cont.action}`}>{cont.label}</a>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="contact__form-holder">
              <div className="contact__form-holder__title">
                <h2>or just send me email</h2>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
